const table = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M15 1v14H1V1zm-7.75 9.833H2.5V13.5h4.75zm6.25 0H8.75V13.5h4.75zM7.25 6.666H2.5v2.667h4.75zm6.25 0H8.75v2.667h4.75zM7.25 2.5H2.5v2.666h4.75zm6.25 0H8.75v2.666h4.75z"/></svg>',
};

export { table as default };
